import React, { useState } from "react";
import { Carousel } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFunnelDollar,
  faChartLine,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
// import Slide1 from "../assets/img/Landing1.jpeg";
// import Slide2 from "../assets/img/omni-m.jpeg";
// import Slide3 from "../assets/img/fromhome.jpeg";
// import Slide5 from "../assets/img/Slide5.jpg";
import testSlide1 from "../assets/img/testSlide1.jpg";
// import testSlide2 from "../assets/img/testSlide2.jpg";
import testSlide3 from "../assets/img/testSlide3.jpg";
import testSlide4 from "../assets/img/testSlide4.jpg";
// import testSlide5 from "../assets/img/testSlide5.jpg";
import testSlide6 from "../assets/img/testSlide6.jpg";
// import Slide7 from "../assets/img/Slide7.jpeg";

const LandingCarousel = () => {
  const [visibleDropdown, setVisibleDropdown] = useState(null);
  const toggleDropdown = (index) => {
    setVisibleDropdown(visibleDropdown === index ? null : index);
  };

  return (
    <div id="landing-carousel">
      <Carousel fade>
        <Carousel.Item>
          <img className="d-block w-100" src={testSlide1} alt="First slide" />
          <Carousel.Caption>
            <div className="caption-details">
              <h1>
                Transform your Customer Engagement with AI-Powered Solutions
              </h1>
              <NavLink to="/business-process-outsourcing" exact>
                <button>Get Started</button>
              </NavLink>
            </div>
          </Carousel.Caption>
        </Carousel.Item>

        {/* <Carousel.Item>
          <img className="d-block w-100" src={testSlide2} alt="First slide" />
          <Carousel.Caption>
            <div className="caption-details">
              <h1>
                Digital Marketing that delivers customer engagement at every
                touch point in real life
              </h1>
              <NavLink to="/customer-engagement-Solutions" exact>
                <button>Get Started</button>
              </NavLink>
            </div>
          </Carousel.Caption>
        </Carousel.Item> */}

        <Carousel.Item>
          <img className="d-block w-100" src={testSlide3} alt="Second slide" />
          <Carousel.Caption>
            <div className="caption-details">
              <h1>
                Increase Customer satisfaction by 55% and issue resolution by
                90% with our contact center
              </h1>
              <NavLink to="/customer-engagement-Solutions" exact>
                <button>Get Started</button>
              </NavLink>
            </div>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img className="d-block w-100" src={testSlide4} alt="Third slide" />
          <Carousel.Caption>
            <div className="caption-details">
              <h1>
                Set up a remote contact center in 3 days. Get your contact
                center work from home ready.
              </h1>
              <NavLink to="/be-work-from-home-ready" exact>
                <button>Get Started</button>
              </NavLink>
            </div>
          </Carousel.Caption>
        </Carousel.Item>

        {/* <Carousel.Item>
          <img className="d-block w-100" src={testSlide5} alt="fourth slide" />
          <Carousel.Caption>
            <div className="caption-details">
              <h1>
                Accelerate your time to success based on repeatable methodology
                with cloud solutions.
              </h1>
              <NavLink to="/cloud-solutions" exact>
                <button>Get Started</button>
              </NavLink>
            </div>
          </Carousel.Caption>
        </Carousel.Item> */}
        <Carousel.Item>
          <img className="d-block w-100" src={testSlide6} alt="sixth slide" />
          <Carousel.Caption>
            <div className="caption-details">
              <h1>Reduce Overhead cost With our BPO Services.</h1>
              <NavLink to="/case-studies" exact>
                <button>Get Started</button>
              </NavLink>
            </div>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
      <div className="intro-cards" data-aos="fade-up">
        <div className="intro-cards-container">
          <div className="intro-card">
            <div className="intro-icon">
              <FontAwesomeIcon icon={faFunnelDollar} />
            </div>
            <h5 onClick={() => toggleDropdown(1)} style={{ cursor: "pointer" }}>
              AML Solutions
            </h5>
            {visibleDropdown === 1 && (
              <select className="dropdown">
                <option value="tool1">Fraud Detection & Prevention</option>
                <option value="tool2">
                  Anti-Money Laundering (AML) Compliance
                </option>
                <option value="tool3">Observability & Risk Intelligence</option>
                <option value="tool3">AI-Driven Threat Intelligence</option>
              </select>
            )}
          </div>
          {/* <div className="intro-card">
            <div className="intro-icon">
              <FontAwesomeIcon icon={faChartLine} />
            </div>
            <h5 onClick={() => toggleDropdown(2)} style={{ cursor: "pointer" }}>
              Business Productivity Tools
              </h5>
            {visibleDropdown === 2 && (
            <select className="dropdown">
               <option value="tool1">Managed Services</option>
               <option value="tool2">Contact Center Outsourcing</option>
               <option value="tool3">Data Processing</option>
            </select>
             )}
          </div> */}
          <div className="intro-card">
            <div className="intro-icon">
              <FontAwesomeIcon icon={faChartLine} />
            </div>
            <h5 onClick={() => toggleDropdown(2)} style={{ cursor: "pointer" }}>
              Customer Lifecycle Management (CLM)
            </h5>
            {visibleDropdown === 2 && (
              <select className="dropdown">
                <option value="tool1">Smart Segmentation</option>
                <option value="tool2">Proactive Engagement</option>
                <option value="tool3">Churn Prevention</option>
                <option value="tool3">Reactivation Strategies</option>
              </select>
            )}
          </div>
          {/* <div className="intro-card">
            <div className="intro-icon">
              <FontAwesomeIcon icon={faUsers} />
            </div>
            <h5 onClick={() => toggleDropdown(3)} style={{ cursor: "pointer" }}>
              Omni Channel Solutions
            </h5>
            {visibleDropdown === 3 && (
            <select className="dropdown">
               <option value="tool1">Deployment Services</option>
               <option value="tool2">Data Collection & Unification</option>
               <option value="tool3">Give Customers control</option>
               <option value="tool3">Data Collection & Unification</option>
            </select>
            )}
          </div> */}
          <div className="intro-card">
            <div className="intro-icon">
              <FontAwesomeIcon icon={faUsers} />
            </div>
            <h5 onClick={() => toggleDropdown(3)} style={{ cursor: "pointer" }}>
              Business process outsourcing
            </h5>
            {visibleDropdown === 3 && (
              <select className="dropdown">
                <option value="tool1">Managed Services</option>
                <option value="tool2">Contact Center Outsourcing</option>
                <option value="tool3">Data Processing</option>
              </select>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingCarousel;
